module.exports = __webpack_public_path__ + "img/header-background-2560.83f22d7.svg";